<template>
    <div class="basket">
        <a :href="stepOne"
           class="mr-0 js-ga-event"
           data-page-area="header"
           data-type="link"
           data-name="cart"
           data-action="href"
           :data-destination-url="stepOne"
        >
            <img src="/img/icons/basket.svg" v-svg-inline>
            <span class="count">{{ quantity }}</span>
        </a>

        <div class="cart-content">
            <div class="top">
                <p v-if="quantity > 0">{{ title }}</p>
                <ul v-if="quantity > 0">
                    <li v-for="(product, key) in cartContent"
                        :key="key"
                    >
                        <template v-if="product.attributes.main">
                            <a :href="'/produkt/' + product.attributes.main.slug"
                               class="cart-product"
                            >
                                <figure>
                                    <img :src="product.attributes.main.product_preview"
                                         loading="lazy"
                                         :alt="product.attributes.main.name"
                                    >
                                </figure>
                                <div class="name">
                                    <p>{{ product.quantity }} x {{ product.attributes.main.name }}</p>
                                    <span>{{ product.attributes.tag_text }}</span>
                                </div>
                            </a>
                        </template>

                        <template v-else>
                            <a :href="'/produkt/' + product.attributes.slug" class="cart-product">
                                <figure>
                                    <img :src="product.attributes.product_preview"
                                         loading="lazy"
                                         :alt="product.name"
                                    >
                                </figure>
                                <div class="name">
                                    <p>{{ product.quantity }} x {{ product.name }}</p>
                                    <span>{{ product.attributes.tag_text }}</span>
                                </div>
                            </a>
                        </template>

                        <span class="price">
                            {{ (product.quantity * product.price).toFixed(2) }}{{ currency }}
                        </span>
                        <a :href="'/kosik/odstranit/' + product.id" class="remove">
                            <img src="/img/icons/remove-2.svg" v-svg-inline>
                        </a>
                    </li>
                </ul>
                <p v-else class="empty">{{ emptyCart }}</p>
            </div>
            <div class="bottom" v-if="quantity > 0">
                <p class="total">
                    {{ totalText }}
                    <strong>{{ totalPrice }} {{ currency }}</strong>
                </p>
                <a :href="stepOne" class="button add-to-cart">
                    {{ btnText }}
                    <img src="/img/icons/cart.svg" v-svg-inline>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, inject, onMounted } from 'vue'

export default {

    props: [
        'tooltipText',
        'quantityP',
        'title',
        'emptyCart',
        'btnText',
        'totalText',
        'totalPriceP',
        'cartContentP',
        'stepOne'
    ],

    setup(props) {

        const emitter  = inject('emitter')
        const constants = inject('constants')

        const state = reactive({
            quantity: 0,
            cartContent: props.quantityP > 0 ? props.cartContentP : {},
            totalPrice: props.totalPriceP
        })

        onMounted( () => {
            state.quantity = props.quantityP

            emitter.on('update-basket', (data) => {
                state.quantity = data.quantity
                state.cartContent[data.cartItem.id] = data.cartItem
                state.totalPrice = data.totalPrice
            })
        })

        return {
            ...toRefs(state),
            ...toRefs(constants)
        }
    }
}
</script>
